import * as React from 'react';
import { Component, createContext, PropsWithChildren } from 'react';
import { ClientShortHandName } from '@snoam/mono-scc';

enum Themes {
  DEFAULT = 'pinata-bundle.css',
  AP = 'ap-bundle.css',
  SA = 'sa-bundle.css',
  BTI = 'bt-bundle.css',
  VNY = 'vny-bundle.css',
  BYN = 'byn-bundle.css',
  STR = 'str-bundle.css',
  ASK = 'ask-bundle.css',
  SCH = 'sch-bundle.css',
  VG = 'vg-bundle.css',
  E24 = 'e24-bundle.css',
  DP = 'e24-bundle.css', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  MPL = 'amag-bundle.css',
}

export interface IThemeContext {
  themeCss: Themes;
}

const ThemeContext = createContext<IThemeContext>({ themeCss: Themes.DEFAULT });

export const ThemeConsumer = ThemeContext.Consumer;

export interface IThemeProviderProps {
  clientShortHandName: ClientShortHandName;
}

export interface IThemeProviderState {
  theme: Themes;
}

export class ThemeProvider extends Component<
  PropsWithChildren<IThemeProviderProps>,
  IThemeProviderState
> {
  public static displayName = 'ThemeProvider';

  public render() {
    const { clientShortHandName } = this.props;
    let theme = Themes[clientShortHandName];
    if (!theme) {
      theme = Themes.DEFAULT;
    }

    return (
      <ThemeContext.Provider value={{ themeCss: theme }}>
        {this.props.children}
      </ThemeContext.Provider>
    );
  }
}
